import _toConsumableArray from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/runner/_work/instore-core/instore-core/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import "core-js/modules/esnext.string.replace-all.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */
var $81812865b3bb9d70$var$formatterCache = new Map();
var $81812865b3bb9d70$var$supportsSignDisplay = false;

try {
  // @ts-ignore
  $81812865b3bb9d70$var$supportsSignDisplay = new Intl.NumberFormat('de-DE', {
    signDisplay: 'exceptZero'
  }).resolvedOptions().signDisplay === 'exceptZero'; // eslint-disable-next-line no-empty
} catch (e) {}

var $81812865b3bb9d70$var$supportsUnit = false;

try {
  // @ts-ignore
  $81812865b3bb9d70$var$supportsUnit = new Intl.NumberFormat('de-DE', {
    style: 'unit',
    unit: 'degree'
  }).resolvedOptions().style === 'unit'; // eslint-disable-next-line no-empty
} catch (e1) {} // Polyfill for units since Safari doesn't support them yet. See https://bugs.webkit.org/show_bug.cgi?id=215438.
// Currently only polyfilling the unit degree in narrow format for ColorSlider in our supported locales.
// Values were determined by switching to each locale manually in Chrome.


var $81812865b3bb9d70$var$UNITS = {
  degree: {
    narrow: {
      default: '°',
      'ja-JP': ' 度',
      'zh-TW': '度',
      'sl-SI': ' °'
    }
  }
};

var $81812865b3bb9d70$export$cc77c4ff7e8673c5 = /*#__PURE__*/function () {
  function $81812865b3bb9d70$export$cc77c4ff7e8673c5(locale) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, $81812865b3bb9d70$export$cc77c4ff7e8673c5);

    this.numberFormatter = $81812865b3bb9d70$var$getCachedNumberFormatter(locale, options);
    this.options = options;
  }

  _createClass($81812865b3bb9d70$export$cc77c4ff7e8673c5, [{
    key: "format",
    value: function format(value) {
      var res = '';
      if (!$81812865b3bb9d70$var$supportsSignDisplay && this.options.signDisplay != null) res = $81812865b3bb9d70$export$711b50b3c525e0f2(this.numberFormatter, this.options.signDisplay, value);else res = this.numberFormatter.format(value);

      if (this.options.style === 'unit' && !$81812865b3bb9d70$var$supportsUnit) {
        var ref;

        var _this$resolvedOptions = this.resolvedOptions(),
            unit = _this$resolvedOptions.unit,
            _this$resolvedOptions2 = _this$resolvedOptions.unitDisplay,
            unitDisplay = _this$resolvedOptions2 === void 0 ? 'short' : _this$resolvedOptions2,
            locale = _this$resolvedOptions.locale;

        var values = (ref = $81812865b3bb9d70$var$UNITS[unit]) === null || ref === void 0 ? void 0 : ref[unitDisplay];
        res += values[locale] || values.default;
      }

      return res;
    }
  }, {
    key: "formatToParts",
    value: function formatToParts(value) {
      // TODO: implement signDisplay for formatToParts
      // @ts-ignore
      return this.numberFormatter.formatToParts(value);
    }
  }, {
    key: "resolvedOptions",
    value: function resolvedOptions() {
      var options = this.numberFormatter.resolvedOptions();
      if (!$81812865b3bb9d70$var$supportsSignDisplay && this.options.signDisplay != null) options = _objectSpread(_objectSpread({}, options), {}, {
        signDisplay: this.options.signDisplay
      });
      if (!$81812865b3bb9d70$var$supportsUnit && this.options.style === 'unit') options = _objectSpread(_objectSpread({}, options), {}, {
        style: 'unit',
        unit: this.options.unit,
        unitDisplay: this.options.unitDisplay
      });
      return options;
    }
  }]);

  return $81812865b3bb9d70$export$cc77c4ff7e8673c5;
}();

function $81812865b3bb9d70$var$getCachedNumberFormatter(locale) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options = options,
      numberingSystem = _options.numberingSystem;
  if (numberingSystem && locale.indexOf('-u-nu-') === -1) locale = "".concat(locale, "-u-nu-").concat(numberingSystem);

  if (options.style === 'unit' && !$81812865b3bb9d70$var$supportsUnit) {
    var ref;
    var _options2 = options,
        unit = _options2.unit,
        _options2$unitDisplay = _options2.unitDisplay,
        unitDisplay = _options2$unitDisplay === void 0 ? 'short' : _options2$unitDisplay;
    if (!unit) throw new Error('unit option must be provided with style: "unit"');
    if (!((ref = $81812865b3bb9d70$var$UNITS[unit]) === null || ref === void 0 ? void 0 : ref[unitDisplay])) throw new Error("Unsupported unit ".concat(unit, " with unitDisplay = ").concat(unitDisplay));
    options = _objectSpread(_objectSpread({}, options), {}, {
      style: 'decimal'
    });
  }

  var cacheKey = locale + (options ? Object.entries(options).sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
  }).join() : '');
  if ($81812865b3bb9d70$var$formatterCache.has(cacheKey)) return $81812865b3bb9d70$var$formatterCache.get(cacheKey);
  var numberFormatter = new Intl.NumberFormat(locale, options);
  $81812865b3bb9d70$var$formatterCache.set(cacheKey, numberFormatter);
  return numberFormatter;
}

function $81812865b3bb9d70$export$711b50b3c525e0f2(numberFormat, signDisplay, num) {
  if (signDisplay === 'auto') return numberFormat.format(num);else if (signDisplay === 'never') return numberFormat.format(Math.abs(num));else {
    var needsPositiveSign = false;
    if (signDisplay === 'always') needsPositiveSign = num > 0 || Object.is(num, 0);else if (signDisplay === 'exceptZero') {
      if (Object.is(num, -0) || Object.is(num, 0)) num = Math.abs(num);else needsPositiveSign = num > 0;
    }

    if (needsPositiveSign) {
      var negative = numberFormat.format(-num);
      var noSign = numberFormat.format(num); // ignore RTL/LTR marker character

      var minus = negative.replace(noSign, '').replace(/\u200e|\u061C/, '');
      if (_toConsumableArray(minus).length !== 1) console.warn('@react-aria/i18n polyfill for NumberFormat signDisplay: Unsupported case');
      var positive = negative.replace(noSign, '!!!').replace(minus, '+').replace('!!!', noSign);
      return positive;
    } else return numberFormat.format(num);
  }
}

var $ad41ad2a9f71fc3e$var$CURRENCY_SIGN_REGEX = new RegExp('^.*\\(.*\\).*$');
var $ad41ad2a9f71fc3e$var$NUMBERING_SYSTEMS = ['latn', 'arab', 'hanidec'];

var $ad41ad2a9f71fc3e$export$cd11ab140839f11d = /*#__PURE__*/function () {
  function $ad41ad2a9f71fc3e$export$cd11ab140839f11d(locale) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, $ad41ad2a9f71fc3e$export$cd11ab140839f11d);

    this.locale = locale;
    this.options = options;
  }

  _createClass($ad41ad2a9f71fc3e$export$cd11ab140839f11d, [{
    key: "parse",
    value:
    /**
    * Parses the given string to a number. Returns NaN if a valid number could not be parsed.
    */
    function parse(value) {
      return $ad41ad2a9f71fc3e$var$getNumberParserImpl(this.locale, this.options, value).parse(value);
    }
    /**
    * Returns whether the given string could potentially be a valid number. This should be used to
    * validate user input as the user types. If a `minValue` or `maxValue` is provided, the validity
    * of the minus/plus sign characters can be checked.
    */

  }, {
    key: "isValidPartialNumber",
    value: function isValidPartialNumber(value, minValue, maxValue) {
      return $ad41ad2a9f71fc3e$var$getNumberParserImpl(this.locale, this.options, value).isValidPartialNumber(value, minValue, maxValue);
    }
    /**
    * Returns a numbering system for which the given string is valid in the current locale.
    * If no numbering system could be detected, the default numbering system for the current
    * locale is returned.
    */

  }, {
    key: "getNumberingSystem",
    value: function getNumberingSystem(value) {
      return $ad41ad2a9f71fc3e$var$getNumberParserImpl(this.locale, this.options, value).options.numberingSystem;
    }
  }]);

  return $ad41ad2a9f71fc3e$export$cd11ab140839f11d;
}();

var $ad41ad2a9f71fc3e$var$numberParserCache = new Map();

function $ad41ad2a9f71fc3e$var$getNumberParserImpl(locale, options, value) {
  // First try the default numbering system for the provided locale
  var defaultParser = $ad41ad2a9f71fc3e$var$getCachedNumberParser(locale, options); // If that doesn't match, and the locale doesn't include a hard coded numbering system,
  // try each of the other supported numbering systems until we find one that matches.

  if (!locale.includes('-nu-') && !defaultParser.isValidPartialNumber(value)) {
    var _iterator = _createForOfIteratorHelper($ad41ad2a9f71fc3e$var$NUMBERING_SYSTEMS),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var numberingSystem = _step.value;

        if (numberingSystem !== defaultParser.options.numberingSystem) {
          var parser = $ad41ad2a9f71fc3e$var$getCachedNumberParser(locale + (locale.includes('-u-') ? '-nu-' : '-u-nu-') + numberingSystem, options);
          if (parser.isValidPartialNumber(value)) return parser;
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return defaultParser;
}

function $ad41ad2a9f71fc3e$var$getCachedNumberParser(locale, options) {
  var cacheKey = locale + (options ? Object.entries(options).sort(function (a, b) {
    return a[0] < b[0] ? -1 : 1;
  }).join() : '');
  var parser = $ad41ad2a9f71fc3e$var$numberParserCache.get(cacheKey);

  if (!parser) {
    parser = new $ad41ad2a9f71fc3e$var$NumberParserImpl(locale, options);
    $ad41ad2a9f71fc3e$var$numberParserCache.set(cacheKey, parser);
  }

  return parser;
} // The actual number parser implementation. Instances of this class are cached
// based on the locale, options, and detected numbering system.


var $ad41ad2a9f71fc3e$var$NumberParserImpl = /*#__PURE__*/function () {
  function $ad41ad2a9f71fc3e$var$NumberParserImpl(locale) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, $ad41ad2a9f71fc3e$var$NumberParserImpl);

    this.formatter = new Intl.NumberFormat(locale, options);
    this.options = this.formatter.resolvedOptions();
    this.symbols = $ad41ad2a9f71fc3e$var$getSymbols(this.formatter, this.options, options);
  }

  _createClass($ad41ad2a9f71fc3e$var$NumberParserImpl, [{
    key: "parse",
    value: function parse(value) {
      // to parse the number, we need to remove anything that isn't actually part of the number, for example we want '-10.40' not '-10.40 USD'
      var fullySanitizedValue = this.sanitize(value); // Remove group characters, and replace decimal points and numerals with ASCII values.

      fullySanitizedValue = $ad41ad2a9f71fc3e$var$replaceAll(fullySanitizedValue, this.symbols.group, '').replace(this.symbols.decimal, '.').replace(this.symbols.minusSign, '-').replace(this.symbols.numeral, this.symbols.index);
      var newValue = fullySanitizedValue ? +fullySanitizedValue : NaN;
      if (isNaN(newValue)) return NaN; // accounting will always be stripped to a positive number, so if it's accounting and has a () around everything, then we need to make it negative again

      if (this.options.currencySign === 'accounting' && $ad41ad2a9f71fc3e$var$CURRENCY_SIGN_REGEX.test(value)) newValue = -1 * newValue; // when reading the number, if it's a percent, then it should be interpreted as being divided by 100

      if (this.options.style === 'percent') {
        newValue /= 100;

        var _maximumFractionDigits; // after dividing to get the percent value, javascript may get .0210999999 instead of .0211, so fix the number of fraction digits


        newValue = +newValue.toFixed(((_maximumFractionDigits = this.options.maximumFractionDigits) !== null && _maximumFractionDigits !== void 0 ? _maximumFractionDigits : 0) + 2);
      }

      return newValue;
    }
  }, {
    key: "sanitize",
    value: function sanitize(value) {
      // Remove literals and whitespace, which are allowed anywhere in the string
      value = value.replace(this.symbols.literals, ''); // Replace the ASCII minus sign with the minus sign used in the current locale
      // so that both are allowed in case the user's keyboard doesn't have the locale's minus sign.

      value = value.replace('-', this.symbols.minusSign); // In arab numeral system, their decimal character is 1643, but most keyboards don't type that
      // instead they use the , (44) character or apparently the (1548) character.

      if (this.options.numberingSystem === 'arab') {
        value = value.replace(',', this.symbols.decimal);
        value = value.replace(String.fromCharCode(1548), this.symbols.decimal);
        value = $ad41ad2a9f71fc3e$var$replaceAll(value, '.', this.symbols.group);
      } // fr-FR group character is char code 8239, but that's not a key on the french keyboard,
      // so allow 'period' as a group char and replace it with a space


      if (this.options.locale === 'fr-FR') value = $ad41ad2a9f71fc3e$var$replaceAll(value, '.', String.fromCharCode(8239));
      return value;
    }
  }, {
    key: "isValidPartialNumber",
    value: function isValidPartialNumber(value) {
      var minValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -Infinity;
      var maxValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Infinity;
      value = this.sanitize(value); // Remove minus or plus sign, which must be at the start of the string.

      if (value.startsWith(this.symbols.minusSign) && minValue < 0) value = value.slice(this.symbols.minusSign.length);else if (this.symbols.plusSign && value.startsWith(this.symbols.plusSign) && maxValue > 0) value = value.slice(this.symbols.plusSign.length); // Numbers cannot start with a group separator

      if (value.startsWith(this.symbols.group)) return false; // Remove numerals, groups, and decimals

      value = $ad41ad2a9f71fc3e$var$replaceAll(value, this.symbols.group, '').replace(this.symbols.numeral, '').replace(this.symbols.decimal, ''); // The number is valid if there are no remaining characters

      return value.length === 0;
    }
  }]);

  return $ad41ad2a9f71fc3e$var$NumberParserImpl;
}();

var $ad41ad2a9f71fc3e$var$nonLiteralParts = new Set(['decimal', 'fraction', 'integer', 'minusSign', 'plusSign', 'group']);

function $ad41ad2a9f71fc3e$var$getSymbols(formatter, intlOptions, originalOptions) {
  var ref, ref1, ref2, ref3; // Note: some locale's don't add a group symbol until there is a ten thousands place

  var allParts = formatter.formatToParts(-10000.111);
  var posAllParts = formatter.formatToParts(10000.111);
  var singularParts = formatter.formatToParts(1);
  var ref4;
  var minusSign = (ref4 = (ref = allParts.find(function (p) {
    return p.type === 'minusSign';
  })) === null || ref === void 0 ? void 0 : ref.value) !== null && ref4 !== void 0 ? ref4 : '-';
  var plusSign = (ref1 = posAllParts.find(function (p) {
    return p.type === 'plusSign';
  })) === null || ref1 === void 0 ? void 0 : ref1.value; // Safari does not support the signDisplay option, but our number parser polyfills it.
  // If no plus sign was returned, but the original options contained signDisplay, default to the '+' character.
  // @ts-ignore

  if (!plusSign && ((originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === 'exceptZero' || (originalOptions === null || originalOptions === void 0 ? void 0 : originalOptions.signDisplay) === 'always')) plusSign = '+';
  var decimal = (ref2 = allParts.find(function (p) {
    return p.type === 'decimal';
  })) === null || ref2 === void 0 ? void 0 : ref2.value;
  var group = (ref3 = allParts.find(function (p) {
    return p.type === 'group';
  })) === null || ref3 === void 0 ? void 0 : ref3.value; // this set is also for a regex, it's all literals that might be in the string we want to eventually parse that
  // don't contribute to the numerical value

  var pluralLiterals = allParts.filter(function (p) {
    return !$ad41ad2a9f71fc3e$var$nonLiteralParts.has(p.type);
  }).map(function (p) {
    return $ad41ad2a9f71fc3e$var$escapeRegex(p.value);
  });
  var singularLiterals = singularParts.filter(function (p) {
    return !$ad41ad2a9f71fc3e$var$nonLiteralParts.has(p.type);
  }).map(function (p) {
    return $ad41ad2a9f71fc3e$var$escapeRegex(p.value);
  });

  var sortedLiterals = _toConsumableArray(new Set([].concat(_toConsumableArray(singularLiterals), _toConsumableArray(pluralLiterals)))).sort(function (a, b) {
    return b.length - a.length;
  });

  var literals = new RegExp("".concat(sortedLiterals.join('|'), "|[\\p{White_Space}]"), 'gu'); // These are for replacing non-latn characters with the latn equivalent

  var numerals = _toConsumableArray(new Intl.NumberFormat(intlOptions.locale, {
    useGrouping: false
  }).format(9876543210)).reverse();

  var indexes = new Map(numerals.map(function (d, i) {
    return [d, i];
  }));
  var numeral = new RegExp("[".concat(numerals.join(''), "]"), 'g');

  var index = function index(d) {
    return String(indexes.get(d));
  };

  return {
    minusSign: minusSign,
    plusSign: plusSign,
    decimal: decimal,
    group: group,
    literals: literals,
    numeral: numeral,
    index: index
  };
}

function $ad41ad2a9f71fc3e$var$replaceAll(str, find, replace) {
  // @ts-ignore
  if (str.replaceAll) // @ts-ignore
    return str.replaceAll(find, replace);
  return str.split(find).join(replace);
}

function $ad41ad2a9f71fc3e$var$escapeRegex(string) {
  return string.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

export { $81812865b3bb9d70$export$cc77c4ff7e8673c5 as NumberFormatter, $ad41ad2a9f71fc3e$export$cd11ab140839f11d as NumberParser };